import * as z from "zod/v4";

export const getProductVendors = {
  name: "getProductVendors" as const,
  input: z.null(),
  output: z.object({ vendors: z.array(z.string()) }),
};
